<template>
  <v-toolbar :class="toolbarColor" dark app clipped-left fixed>
    <v-toolbar-side-icon @click.stop="toggleMenu"></v-toolbar-side-icon>
    <v-toolbar-title style="width: 225px">
      <router-link :to="{ name: 'dashboard' }" class="brandlogo" id="logo">
        <template v-if="$mode === 'uoi'">
          <v-avatar :tile="true" :size="25">
            <img src="/static/img/uoi-gate.svg" alt="logo">
          </v-avatar>
        </template>
        {{mainTitle}}
      </router-link>
    </v-toolbar-title>
    <search propclass="hidden-sm-and-down"></search>
    <v-spacer></v-spacer>
    <v-btn icon class="hidden-md-and-up" @click="toggleSearch">
      <v-icon>mdi-magnify</v-icon>
    </v-btn>
    <!--
      Open only if the feature is usable
      <v-btn icon @click="openDBSearch">
        <v-icon>mdi-database-search</v-icon>
      </v-btn>
    -->
    <v-menu offset-y :close-on-content-click="false" v-model="notification" :lazy="true" light>
      <v-btn icon slot="activator" id="notificationBtn" dark>
        <v-badge left color="red" overlap>
          <span slot="badge" v-if="hasNotification">{{newNotificationCount}}</span>
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
      <notification-list :notificationOpen="notification"></notification-list>
    </v-menu>
    <v-menu offset-y light>
      <v-btn icon slot="activator" id="userSettingsBtn" dark>
        <v-avatar size="32px" tile>
          <span class="white--text avatarText">{{$store.getters.userInitials}}</span>
        </v-avatar>
      </v-btn>
      <v-list>
        <v-list-tile @click="$router.push({ name: 'profile'})">
          <v-list-tile-content>
            <v-list-tile-title>User Settings</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon>mdi-account-settings-variant</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile @click="$router.push({ name: 'rptJobs'})">
          <v-list-tile-content>
            <v-list-tile-title>Report History</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon>mdi-file-document-box</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile @click="doLogout">
          <v-list-tile-content>
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>
import Search from './search/Search'
import NotificationList from '../misc/notification/NotificationList'
import { APP_TOGGLE_MENU, APP_TOGGLE_SEARCH } from '@/store/types'
import { setCookie } from '@/utils/cookie'

export default {
  data() {
    return {
      notification: false
    }
  },
  computed: {
    toolbarColor() {
      // For top bar, I feel a darker color looks nicer
      return this.$store.getters.toolbarColor
    },
    mainTitle() {
      return this.$store.state.app.projectTitle
    },
    hasNotification() {
      if (this.$store.state.user.notification.newCount !== undefined && this.$store.state.user.notification.newCount > 0) {
        return true
      } else {
        return false
      }
    },
    newNotificationCount() {
      if (this.$store.state.user.notification.newCount !== undefined && this.$store.state.user.notification.newCount > 0) {
        return this.$store.state.user.notification.newCount
      } else {
        return false
      }
    }
  },
  methods: {
    toggleMenu() {
      this.$store.commit(APP_TOGGLE_MENU)
      // For user manual trigger, save the state to cookie
      if (this.$store.state.app.toggleMenu) {
        setCookie('menu', true)
      } else {
        setCookie('menu', false)
      }
    },
    toggleSearch() {
      this.$store.commit(APP_TOGGLE_SEARCH)
    },
    doLogout() {
      this.$store.dispatch('logout', true)
    },
    openDBSearch() {
      this.$store.dispatch('dataSearchOpen')
    }
  },
  components: {
    Search,
    NotificationList
  }
}
</script>

<style lang="scss">
.brandlogo {
  color: #fff !important;
  text-decoration: none;
}
.avatarText {
  font-size: 20px !important;
  font-weight: 500;
  line-height: 32px !important;
  letter-spacing: normal !important;
}
</style>
